import { useCallback, useState, useRef, useEffect } from "react";
import { useScrolling } from "@foundation/scroll";

export const useStickyNav = () => {
    const navRef = useRef<HTMLElement | null>(null);
    const [transitionCSS, setTransitionCSS] = useState({ top: "0px" });

    useEffect(() => {
        navRef.current = document.getElementById("nav-container");
    }, []);

    useEffect(() => {
        if (navRef.current) {
            navRef.current.style.top = transitionCSS.top;
        }
    }, [transitionCSS]);

    const onScrollUpCallback = useCallback(() => {
        setTransitionCSS({ top: "0px" });
    }, []);

    const onScrollDownCallback = useCallback(() => {
        if (navRef.current) {
            const componentHeight = navRef.current.clientHeight;
            setTransitionCSS({ top: `-${componentHeight}px` });
        }
    }, [navRef.current]);

    useScrolling({
        scrollingElementRef: navRef,
        scrollDirectionThreshold: 30,
        onScrollUpCallback,
        onScrollDownCallback,
    });
};
